var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGolf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.5,8.4c-0.9-0.9-2.2-1.5-3.6-1.5c-1.4,0-2.7,0.6-3.6,1.5l-2.3,2.3h-73c-0.6,0-1.3,0.2-1.8,0.5c-0.4,0.2-0.7,0.4-1,0.7 l-1.8,1.8c-1.7,1.7-1.7,4.6,0.1,6.3c1.7,1.6,4.4,1.5,6-0.2l6.5-6.6h62.4L70.9,36.7c-1,1-1.5,2.3-1.5,3.6V72h23.1V45.5h10.3 c2.8,0,5.1-2.3,5.1-5.1V12.1C108,10.7,107.4,9.4,106.5,8.4z M87,35.2l10.7-10.7v10.7H87z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63,
    cy: 25.7,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4,105.9l-24.2,24.2c-2,2-2,5.3,0,7.3s5.3,2,7.3,0l25.7-25.7c1-1,1.5-2.3,1.5-3.6V77.1H69.5L69.4,105.9L69.4,105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3,133.7c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1V77.1H82.3V133.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolf);
export default __webpack_public_path__ + "static/media/golf.3231a8921678b716caf4e1a2522ea0b6.svg";
export { ForwardRef as ReactComponent };